import { SettlementDebtsReducer } from './SettlementDebtReducer';
import { SettlementDetailsReducer } from './SettlementDetailReducer';
import { SettlementReducer } from './SettlementReducer';
import { SettlementResumeReducer } from './SettlementResumeReducer';

// state
import { SettlementState } from '../../states/SettlementState';

// Reduce common functions
import * as CommonFunctions from '../Common/Functions';

// Exporta el reducer combinado
export const CombinedPractitionerReducer = CommonFunctions.reduceReducers<SettlementState>(
    SettlementReducer,
    SettlementDebtsReducer,
    SettlementDetailsReducer,
    SettlementResumeReducer,
);

